import React, {
  FC,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import { Swipe, SwipeItem, Image } from '@quarkd/quark-react';
import throttle, {
  getOssImageUrl,
  getVideoCoverUrl,
  getUrlParams,
  downLoadApp,
} from '@/utils/utils';
import { FromNativeOrWxParam, SHARE_WAYS } from '@/interface/downAppType';
import './pic.less';
import { DOWNLOAD_IMG } from '@/constants/config';
import { cardDetailVo, ResShareData, ResUserFeedData } from '@/api/appDownload';
import Videocz from '@/components/video';
import { indexUBT } from '@/utils/pageUbt';

interface Iprops {
  userFeedDetail: cardDetailVo | null;
  userFeedData: ResUserFeedData | null;
  configData: any;
  onDownloadApp?: (options?: {
    selector?: string;
    clipboardStr?: string;
    buttonName?: string;
    includeExtraInfo?: boolean;
  }) => void;
}

const PicC: FC<Iprops> = (props) => {
  const { shareType } = getUrlParams(
    window.location.href || '',
  ) as unknown as FromNativeOrWxParam;
  const [pageStatus, setPageStatus] = useState<SHARE_WAYS>(
    +shareType || SHARE_WAYS.PIC,
  );
  const videoNode = useRef<HTMLVideoElement>(null);
  const containerRef = useRef(null);
  const wrapperRef = useRef(null);
  const [isMi, setIsMi] = useState<boolean>(
    navigator.userAgent.indexOf('MiuiBrowser') !== -1
      || navigator.userAgent.indexOf('qqbrowser') > -1
      || navigator.userAgent.indexOf('Oppo') > -1
      || navigator.userAgent.indexOf('ColorOS') > -1,
  );
  const [maskStatus, setMaskStatus] = useState<boolean>(false);
  const [listRenderAll, setListRenderAll] = useState<boolean>(false);
  const [renderData, setRenderData] = useState<any[]>([]);
  const {
    userFeedDetail, userFeedData, configData, onDownloadApp, 
  } = props;

  /**
   * 处理下载App点击的辅助函数
   * 优先使用父组件传入的 onDownloadApp，否则使用原来的方式
   */
  const handleDownloadClick = useCallback((selector: string, buttonName?: string) => {
    if (onDownloadApp) {
      onDownloadApp({
        selector,
        buttonName,
      });
    } else {
      downLoadApp({ selector });
      if (buttonName) {
        indexUBT.clickButton({
          businessInfo: {},
          buttonName,
        });
      }
    }
  }, [onDownloadApp]);

  let timer: NodeJS.Timeout | null;

  const { picture = [], videos = [], content } = userFeedDetail || {};

  const { commentCount, preferCount } = userFeedData || {};

  useEffect(() => {
    const handleScroll = throttle(() => {
      if (!listRenderAll) {
        setListRenderAll(true);
      }
    }, 300);
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (configData?.momentData?.length) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      setRenderData(configData?.momentData?.slice(0, listRenderAll ? 20 : 4));
    }
  }, [configData, listRenderAll]);

  return (
    <>
      <div className="pic-con">
        <div className="pic-con-video-img">
          {maskStatus && (
            <div className="video-mask">
              <div className="swipers">
                <div className="swipe">
                  {renderData?.map((item: any, i: number) => {
                    const myname = item.nickname || '';
                    const name = myname?.length < 8 ? myname : `${myname.slice(0, 7)}...`;
                    let pics = [];
                    try {
                      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                      pics = JSON.parse(item?.picture || '') || [];
                    } catch (error) {
                      //
                    }
                    return (
                      <div
                        className="swipe-ite"
                        key={i}
                        id={`video-mask-download-${i}`}
                        onClick={() => handleDownloadClick(`#video-mask-download-${i}`)}
                      >
                        <Image
                          lazy={true}
                          fit={'cover'}
                          className="swipe-ite-img"
                          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                          src={getOssImageUrl(pics[0]?.url || '', 464, 620)}
                        />
                        <Image
                          className="swipe-ite-img-play"
                          lazy={true}
                          src={DOWNLOAD_IMG.PAUSE_BTN}
                        />
                        <div className="swipe-ite-msg">
                          <div className="swipe-ite-peo">
                            <Image
                              className="swipe-ite-peo-img"
                              lazy={true}
                              // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                              src={getOssImageUrl(item?.avatar || '', 128, 128)}
                            />
                            {name}
                          </div>
                          <div className="swipe-ite-txt">
                            {item.content || ''}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="video-mask-btns">
                <div
                  className="video-mask-replay"
                  onClick={() => {
                    if (videoNode.current) {
                      setMaskStatus(false);
                      // eslint-disable-next-line no-unused-expressions
                      if (isMi) {
                        setTimeout(() => {
                          videoNode.current?.play();
                        }, 500);
                        return;
                      }
                      videoNode.current?.play();
                    }
                  }}
                >
                  <Image
                    className="video-mask-replay-ico"
                    lazy={true}
                    src={getOssImageUrl(DOWNLOAD_IMG.RE_PLAY, 40, 40)}
                  />
                  再看一遍
                </div>
                <div
                  className="video-mask-download"
                  id="video-mask-download"
                  onClick={() => handleDownloadClick('#video-mask-download')}
                >
                  打开街猫
                </div>
              </div>
            </div>
          )}
          <div className="pic-con-top">
            {pageStatus === SHARE_WAYS.VIDEO ? (
              <>
                {maskStatus && isMi ? (
                  <Image
                    className="pic-con-img"
                    fit={'contain'}
                    lazy={true}
                    src={getVideoCoverUrl(videos[0]?.url || '', 750, 652)}
                  />
                ) : (
                  <Videocz
                    src={videos[0]?.url || ''}
                    poster={getVideoCoverUrl(videos[0]?.url || '', 750, 652)}
                    showController={false}
                    showCenterBtn
                    showBottomProgress
                    pauseBtn={''}
                    onEnded={() => {
                      setMaskStatus(true);
                    }}
                    videoRef={videoNode}
                    pauseBtnClass="pause-btn-class"
                    playBtn={DOWNLOAD_IMG.PAUSE_BTN}
                  />
                )}
              </>
            ) : (
              <>
                {picture?.length > 1 ? (
                  <Swipe className="pic-con-top" onChange={(e) => {}}>
                    {picture?.map((ite, index: number) => (
                      <SwipeItem key={index}>
                        <Image
                          className="pic-con-img"
                          fit={'contain'}
                          lazy={true}
                          src={getOssImageUrl(
                            (ite.url || '') as string,
                            750,
                            652,
                          )}
                        />
                      </SwipeItem>
                    ))}
                  </Swipe>
                ) : (
                  <>
                    {picture?.length ? (
                      <Image
                        className="pic-con-img"
                        fit={'contain'}
                        lazy={true}
                        src={getOssImageUrl(
                          (picture[0]?.url || '') as string,
                          750,
                          652,
                        )}
                      />
                    ) : (
                      ''
                    )}
                  </>
                )}
              </>
            )}
          </div>
          <div className="pic-rich-txt">{content || ''}</div>
          <div className="options">
            <div
              className="pic-input"
              id="download-input"
              onClick={() => handleDownloadClick('#download-input', 'miaowa_h5_index_shuodian_cli')}
            >
              说点什么…
            </div>
            <div className="pic-living-btns">
              <div
                className="pic-feed-cat"
                id="pic-feed-cat"
                onClick={() => handleDownloadClick('#pic-feed-cat', 'miaowa_h5_index_fenxiang_cli')}
              >
                <Image
                  className="pic-feed-cat-img"
                  lazy={true}
                  src={getOssImageUrl(DOWNLOAD_IMG.SURPORT_GOOD, 40, 40)}
                />
                <div className="pic-living-btn-txt">{preferCount || 0}</div>
              </div>
              <div
                className="pic-toggle-perspective"
                id="pic-toggle-perspective"
                onClick={() => handleDownloadClick('#pic-toggle-perspective', 'miaowa_h5_index_tuwenpinglun_cli')}
              >
                <Image
                  className="pic-toggle-perspective-img"
                  lazy={true}
                  src={getOssImageUrl(DOWNLOAD_IMG.WX_CHAT, 40, 40)}
                />
                <div className="pic-living-btn-txt">{commentCount || 0}</div>
              </div>
            </div>
          </div>
          <div className="pic-total-suport">
            <div
              className="pic-total-suport-btn"
              id="pic-total-suport-btn"
              onClick={() => handleDownloadClick('#pic-total-suport-btn', 'miaowa_h5_index_dakaijiemao_cli')}
            >
              打开街猫App免费投喂
            </div>
          </div>
        </div>
        <div className="pic-more-title">更多精彩瞬间</div>
        <div ref={containerRef} className="pic-virtual-lists">
          <div ref={wrapperRef}>
            <div className="pic-vir-items">
              {renderData?.map((item: any, index: number) => {
                const myname = item.nickname || '';
                const name = myname?.length < 8 ? myname : `${myname.slice(0, 7)}...`;
                let pics = [];
                try {
                  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                  pics = JSON.parse(item.picture || null) || [];
                } catch (error) {
                  //
                }
                const goodNums = configData?.catHouseLivingData || [];
                return (
                  <div
                    className="pic-vir-item"
                    key={index}
                    id={`pic-vir-item-${index}`}
                    onClick={() => handleDownloadClick(`#pic-vir-item-${index}`, 'miaowa_h5_index_maowu_cli')}
                  >
                    <Image
                      className="pic-card-img"
                      lazy={true}
                      fit={'cover'}
                      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                      src={getOssImageUrl(pics[0]?.url || '', 340, 252)}
                    />
                    <div className="pic-card-name">{item.content || ''}</div>
                    <div className="pic-card-msg">
                      <div className="pic-card-peo">
                        <Image
                          className="pic-card-p-img"
                          lazy={true}
                          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                          src={getOssImageUrl(item.avatar || '', 28, 24)}
                        />
                        <span
                          style={{
                            display: 'inline-block',
                          }}
                        >
                          {name}
                        </span>
                      </div>
                      <div className="pic-card-feed">
                        <span
                          style={{
                            display: 'inline-block',
                          }}
                        >
                          {goodNums[index]?.feedQuantity || 0}个赞
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(PicC);
